import { render, staticRenderFns } from "./CreatedNoteChat.vue?vue&type=template&id=6c2c0e58&scoped=true&lang=html&"
import script from "./CreatedNoteChat.vue?vue&type=script&lang=js&"
export * from "./CreatedNoteChat.vue?vue&type=script&lang=js&"
import style0 from "./CreatedNoteChat.vue?vue&type=style&index=0&id=6c2c0e58&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c0e58",
  null
  
)

export default component.exports